var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0714 11.4515V14.4992C17.0714 16.7083 15.2806 18.4992 13.0714 18.4992H9C6.79086 18.4992 5 16.7083 5 14.4992V10.4277C5 8.21859 6.79086 6.42773 9 6.42773H11.7602",
    stroke: "#475569",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9615 7.74668L11.8231 13.7847C11.7144 13.8916 11.5827 13.9722 11.4381 14.0204L8.65757 14.9473C8.58608 14.9711 8.51492 14.9103 8.52731 14.836L8.9693 12.184C9.00623 11.9624 9.1167 11.7597 9.2829 11.6086L15.8589 5.62833C15.9379 5.55649 16.0594 5.55937 16.1349 5.63487L17.9627 7.46267C18.0412 7.54123 18.0407 7.66877 17.9615 7.74668Z",
    stroke: "#475569",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.ea1101fd396fa433491d38b277fb0562.svg";
export { ForwardRef as ReactComponent };